module.exports = __webpack_public_path__ + "img/KinokoTable02.0bccbc84.jpg";